<h1 mat-dialog-title>Confirm products {{ Error }}</h1>
<div mat-dialog-content class="col-xs-12 col-sm-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-lg-12 col-xl-12 col-xxl-12">
  <div class="col-xs-12 col-sm-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-lg-12 col-xl-12 col-xxl-12 row"  *ngFor="let item of data">
    <p  class="col-xs-12 col-sm-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-lg-12 col-xl-12 col-xxl-12" >Quantity:{{filterData(item.StatedQuantity)}}</p> 
    <p  class="col-xs-12 col-sm-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-lg-12 col-xl-12 col-xxl-12">ItemNumber:{{item.ItemNumber}}</p>
      <p  class="col-xs-12 col-sm-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-lg-12 col-xl-12 col-xxl-12">Location:{{item.Location}}</p>
      <p  class="col-xs-12 col-sm-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-lg-12 col-xl-12 col-xxl-12">{{item.Id}}</p>
    <mat-form-field class="col-xs-12 col-sm-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-lg-12 col-xl-12 col-xxl-12">
      <mat-label>Quantity</mat-label>
      <input matInput class="col-xs-12 col-sm-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-lg-12 col-xl-12 col-xxl-12" type="number" [(ngModel)]="item.StatedQuantity" />
    </mat-form-field>
   
    <mat-form-field appearance="fill" class="col-xs-12 col-sm-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-lg-12 col-xl-12 col-xxl-12">
      <mat-label>Notes</mat-label>
      <textarea matInput class="col-xs-12 col-sm-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-lg-12 col-xl-12 col-xxl-12" [(ngModel)]="item.Notes"></textarea>
    </mat-form-field>
  </div>
</div>
<div mat-dialog-actions>
  <div class="col-xs-12 col-sm-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-lg-12 col-xl-12 col-xxl-12 row">
    <div class="col-xs-6 col-sm-6 col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 col-lg-6 col-xl-6 col-xxl-6">
      <button
      mat-raised-button
      color="danger"
      (click)="onNoClick()"
      class="col-xs-12 col-sm-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-lg-12 col-xl-12 col-xxl-12"
    >
      Cancel
    </button>
    </div>
    <div class="col-xs-6 col-sm-6 col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 col-lg-6 col-xl-6 col-xxl-6">
      <button
      mat-raised-button
      color="primary"
      (click)="OnConfirmar()"
      class="col-xs-12 col-sm-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-lg-12 col-xl-12 col-xxl-12"
    >
      Confirm
    </button>
    </div>
  </div>
 
 
</div>
